import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PlatInstrumentTablesComponent } from '../plat-instrument-tables';


@Component({
	selector: 'plat-instrument-drill-tables',
	templateUrl: './plat-instrument-drill-tables.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class PlatInstrumentDrillTablesComponent extends PlatInstrumentTablesComponent { }
